// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3F4iJ","range":"MonthRangeSwitch_range__2AVRe","disabled":"MonthRangeSwitch_disabled__3NLYE"};